<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .todo-modal-content {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    overflow: auto;
    height: 100%;
    width: 100%;

    > .main-container {
      display: grid;
      grid-template-columns: 1fr 2fr;
      padding: 0;
      overflow: auto;
      height: 100%;

      // Make space for the campaign header if the modal is a todo modal
      &.isTodo {
        height: calc(100% - utils.in_rem(54px));
      }

      > .todo-panel {
        display: flex;
        flex-direction: column;
        overflow: auto;
        height: 100%;
        width: 100%;

        > .tab-panel-container {
          display: flex;
          flex-direction: column;

          overflow: auto;
          height: 100%;
          width: 100%;

          padding: utils.in_rem(32px);

          &.isTodo {
            padding: utils.in_rem(15px) utils.in_rem(32px);
          }
          &.isContactAI {
            padding-right: 0;
          }
        }
      }
    }
  }
</style>

<script>
  // Components
  import TabPanel from "@sourcewhale/shared/svelte-design-system/components/molecules/TabPanel.svelte";
  import CompanyInsights from "../../elements/CompanyInsights/CompanyInsights.svelte";
  import BottomRow from "./BottomRow/BottomRow.svelte";
  import CampaignInfoHeading from "./CampaignInfoHeading.svelte";
  import EditContact from "./ProfileContactSideBar/EditContact/EditContact.svelte";
  import ProfileContactSideBar from "./ProfileContactSideBar/ProfileContactSideBar.svelte";
  import AskAI from "./Tabs/AskAI/AskAI.svelte";
  // Components - tabs
  import Activity from "./Tabs/Activity.svelte";
  import Background from "./Tabs/Background/Background.svelte";
  import Files from "./Tabs/Files.svelte";
  import Projects from "./Tabs/Projects.svelte";
  import YourToDo from "./Tabs/YourToDo.svelte";
  import {
    activeTabStore,
    backgroundTabViewedStore,
    candidateStore,
    modalBodyHeight,
    showEditContact,
    todoPanelTabs,
    todosModalItemStore,
  } from "./stores";

  let clientHeight = 0;

  activeTabStore.subscribe((tab) => {
    if (tab === "backgroundTab") {
      backgroundTabViewedStore.set(true);
    }
    if (tab === null) {
      backgroundTabViewedStore.set(false);
    }
  });

  $: isTodo = $todosModalItemStore?.toDoId;
  $: kind = $todosModalItemStore?.kind;
  $: isContactAI = $activeTabStore === "askAiTab";

  $: headerStyle = isTodo ? "" : "margin-right: 34px;";

  const getSnippetForTab = (slot) => {
    switch (slot) {
      case "yourToDoTab":
        return yourToDoSnippet;
      case "activityTab":
        return activitySnippet;
      case "backgroundTab":
        return backgroundSnippet;
      case "projectsTab":
        return projectsSnippet;
      case "companyInsightsTab":
        return companyInsightsSnippet;
      case "askAiTab":
        return askAISnippet;
      case "filesTab":
        return contactFilesSnippet;
      default:
        return null;
    }
  };

  $: tabItems = $todoPanelTabs.map((tab) => ({
    ...tab,
    snippet: getSnippetForTab(tab.slot),
  }));
</script>

{#snippet yourToDoSnippet()}
  <YourToDo />
{/snippet}

{#snippet activitySnippet()}
  <Activity />
{/snippet}

{#snippet backgroundSnippet()}
  <Background />
{/snippet}

{#snippet projectsSnippet()}
  <Projects />
{/snippet}

{#snippet companyInsightsSnippet()}
  <CompanyInsights
    isTabOpen={$activeTabStore === "companyInsightsTab"}
    obj={$candidateStore}
    origin="todos"
  />
{/snippet}

{#snippet askAISnippet()}
  <AskAI />
{/snippet}

{#snippet contactFilesSnippet()}
  <Files />
{/snippet}

<div class="todo-modal-content">
  {#if isTodo}
    <CampaignInfoHeading />
  {/if}
  {#if $showEditContact}
    <EditContact />
  {:else}
    <div
      class="main-container"
      class:isTodo
      bind:clientHeight={$modalBodyHeight}
    >
      <ProfileContactSideBar />
      <div class="todo-panel">
        <div
          class="tab-panel-container"
          class:isTodo
          class:isContactAI
          style="height:calc(100% - {clientHeight}px)"
        >
          <TabPanel
            class="flex-1"
            size="small"
            {tabItems}
            bind:activeTab={$activeTabStore}
            {headerStyle}
          />
        </div>
        {#if isTodo && !["opportunity", "aiToDo", "manualToDo"].includes(kind)}
          <BottomRow bind:clientHeight />
        {/if}
      </div>
    </div>
  {/if}
</div>
